import { apiClient } from '@/lib/apiClient';

export interface MetricsSummary {
  created: number;
  resolved: number;
  openAtEnd: number;
  avgFirstResponseHours: number | null;
  avgResolutionHours: number | null;
  slaMet: number;
  slaBreached: number;
  slaPending: number;
  slaCompliancePct: number | null;
}

export interface DailyVolumePoint {
  date: string; // ISO date (yyyy-MM-dd)
  created: number;
  resolved: number;
}

export interface CategoryBreakdown {
  category: string;
  count: number;
  avgResolutionHours: number | null;
}

export interface PriorityBreakdown {
  priority: string;
  target: string;
  count: number;
  slaMet: number;
  slaBreached: number;
  slaPending: number;
  slaCompliancePct: number | null;
}

export interface AssigneeBreakdown {
  assignee: string;
  open: number;
  resolved: number;
}

export interface AgingBucket {
  bucket: string;
  count: number;
}

export interface MetricsReport {
  fromUtc: string;
  toUtc: string;
  summary: MetricsSummary;
  daily: DailyVolumePoint[];
  byCategory: CategoryBreakdown[];
  byPriority: PriorityBreakdown[];
  byAssignee: AssigneeBreakdown[];
  openAging: AgingBucket[];
}

export const metricsApi = {
  /** fromUtc/toUtc are ISO instants; `to` is exclusive. */
  get: (
    fromUtc: string,
    toUtc: string,
    getAccessToken: () => Promise<string>,
    signal?: AbortSignal
  ): Promise<MetricsReport> =>
    apiClient.get<MetricsReport>(
      `/api/metrics?from=${encodeURIComponent(fromUtc)}&to=${encodeURIComponent(toUtc)}`,
      { getAccessToken, signal }
    )
};
